module.exports = __webpack_public_path__ + "img/实验室通风系统4.3875a30d.jpg";